import React, { useEffect } from "react";
import MiniGamePageHome from "../Home";
import { useParams } from "react-router-dom";
import { getDataApi } from "../../../../config/service";
import API_PATH from "../../../../config/API_PATH";
import { useDispatch } from "@pages/Events/MiniGame/store";
import {
  TYPE_GIVE_MINIGAME,
  TYPE_REQUEST_PIECE,
} from "../../../../helper/const";
import {
  setDataPopupError,
  setOpenPopupGivePiece,
} from "../../../../Redux/futures/mini-game/action";

export default function ComponentRequest() {
  const { awardId: id } = useParams();
  const dispatch = useDispatch();

  const handleGetLink = async () => {
    const dataGetLink = await getDataApi(
      `${API_PATH.miniGameGetCodePieceLinkInfo}?code=${id}&type=${TYPE_GIVE_MINIGAME.request}`
    );

    if (!dataGetLink?.data || !dataGetLink?.success) {
      return dispatch(
        setDataPopupError({
          isOpen: true,
          message: dataGetLink?.message || "",
        })
      );
    }
    // success
    dataGetLink.typeWeb = TYPE_GIVE_MINIGAME.request;
    dispatch(
      setOpenPopupGivePiece({
        isShow: true,
        type: TYPE_REQUEST_PIECE.requestConfirm,
        link: id,
        data: dataGetLink,
      })
    );
  };

  useEffect(() => {
    if (!id) {
      return null;
    }

    handleGetLink();
  }, [id]);

  return <MiniGamePageHome />;
}
